/**
 * Server Player Mapper Utility
 * Converts server player order entries to client PlayerInfo format
 */

import type { PlayerOrderEntry } from 'shared-types';
import type { PlayerInfo } from '../components/board/constants/LudoBoard.types';

/**
 * Maps server player order to client PlayerInfo format
 * Calculates pawnsInBase from actual pawn positions
 *
 * @param playerOrder - Array of player order entries from server state
 * @param pawnPositions - Optional pawn positions map (playerId -> position array)
 * @returns Array of PlayerInfo for client-side rendering
 */
export function mapServerPlayersToPlayerInfo(
  playerOrder: PlayerOrderEntry[],
  pawnPositions?: Record<string, number[]>
): PlayerInfo[] {
  return playerOrder.map((p) => {
    // Calculate pawns in base from actual positions (-1 means in base)
    const playerPawns = pawnPositions?.[p.playerId] ?? [-1, -1, -1, -1];
    const pawnsInBase = playerPawns.filter((pos) => pos === -1).length;

    return {
      id: p.playerId,
      pseudo: p.pseudo ?? 'Player',
      color: p.color,
      diceValue: null,
      pawnsInBase,
      skinPreferences: p.skinPreferences
    };
  });
}
